import styled from "styled-components";

export const ModalUpdateContainer = styled.div`
  h2 {
    background: linear-gradient(
      90deg,
      #ff3556 0.08%,
      #ff63a1 25.04%,
      #ffdb87 50%,
      #fff 99.92%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    font-family: Dirtyline;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 100% */
    text-transform: lowercase;
    margin-bottom: 8px;
  }
  .block-avatar {
    text-align: center;
    .current {
      color: rgba(255, 255, 255, 0.75);
      text-align: center;
      font-size: 12.681px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%; /* 15.851px */
      margin-bottom: 8px;
    }
    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin: 0 auto 12px;
      border: 1px solid var(--Neutral-300, #b8b8c1);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .update {
      color: var(--Neutral-50, #f7f7f8);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 16.32px; /* 116.571% */
      margin-bottom: 8px;
    }
  }
  .ant-upload-wrapper.ant-upload-picture-card-wrapper
    .ant-upload.ant-upload-select,
  .ant-upload-wrapper.ant-upload-picture-circle-wrapper
    .ant-upload.ant-upload-select {
    width: 100%;
    height: 232px;
  }
  .ant-upload-wrapper.ant-upload-picture-card-wrapper
    .ant-upload-list.ant-upload-list-picture-card
    .ant-upload-list-item-container,
  .ant-upload-wrapper.ant-upload-picture-circle-wrapper
    .ant-upload-list.ant-upload-list-picture-card
    .ant-upload-list-item-container,
  .ant-upload-wrapper.ant-upload-picture-card-wrapper
    .ant-upload-list.ant-upload-list-picture-circle
    .ant-upload-list-item-container,
  .ant-upload-wrapper.ant-upload-picture-circle-wrapper
    .ant-upload-list.ant-upload-list-picture-circle
    .ant-upload-list-item-container {
    width: 100%;
    height: 232px;
  }
  .list-buttons {
    margin-top: 28px;
    display: flex;
    justify-content: center;
    gap: 12px;
    align-items: center;
    button {
      width: 92px;
      height: 39px;
    }
  }
`;
